// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd7a36ee","821":"1ecee5e3"}[chunkId] + ".chunk.js";
};